import { makeStyles, TableCell, TableRow } from '@material-ui/core';
import React from 'react'
import { formatCurrencyPesos } from '../../../../../../helpers/extraFunctions';

const useRowStyles = makeStyles({
    root: {
        "& > *": {
            borderBottom: "unset",
        },
    },
});

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const ItemsAltaCosto = (props) => {

    const classes = useRowStyles();
    const { item } = props;

    return (
        <TableRow className={classes.root}>
            <TableCell align="left"></TableCell>
            <TableCell align="left">{item?.nroPedScienza}</TableCell>
            <TableCell align="left">{item?.presentacion}</TableCell>
            <TableCell align="left">{item?.cant}</TableCell>
            <TableCell align="left">{item?.medicamento} </TableCell>
            <TableCell align="left">{item?.surge === 1 ? 'SI' : 'NO'}</TableCell>
            <TableCell align="left">{`${formatCurrencyPesos(item?.importe_alfabeta)}`}</TableCell>
            <TableCell align="left">{`${formatCurrencyPesos(item?.importe_aud)}`}</TableCell>
            <TableCell align="left">{item?.apellido_Nombre}</TableCell>
            <TableCell align="left">
                {new Date(item?.fechaPedido).toLocaleString("es", optionsfecha)}
            </TableCell>
            <TableCell align="left">{item?.cod_diag}</TableCell>
            <TableCell align="left">{item?.diagnostico}</TableCell>
        </TableRow>
    )
}

